import * as UI from "@iyk/ui"

type Props = {
  mediaCount: number
}

export const ContentUnlockBadge = ({ mediaCount }: Props) => (
  <div className="bg-black/40 backdrop-blur-md [&>svg]:[filter:drop-shadow(0px_0px_4px_rgba(0,0,0,0.20))] text-white z-10 absolute top-3 left-3 px-1 py-0.5 rounded flex items-center gap-1 text-xs">
    <UI.Icon.Image className="size-3" />
    <p>{mediaCount}</p>
  </div>
)
